import { Box, Typography } from "@bca/ui-library";

import { Vehicle } from "../Interfaces/vehicle.type";
import { formatCollectionTime } from "../formatCollectionTime";
import KeySvg from "../Icons/KeySVG";
import { formatCardCollectionDate } from "../formatCardCollectionDate";

interface CollectionProps {
  vehicle: Vehicle;
  degradedServices: string[];
}

const Collection: React.FunctionComponent<CollectionProps> = ({ vehicle }) => {
  return (
    <Box display="flex" flexDirection="row" alignItems="flex-start" width="50%">
      <KeySvg width={18} height={18} />
      <Box display="flex" flexDirection="column" width="100%" marginLeft={2}>
        <Typography
          variant="h6"
          color="footer-blue"
          fontWeight="medium"
          marginTop={0}
          marginBottom={1}
        >
          Scheduled
        </Typography>
        <Box
          display="flex"
          flexDirection="row"
          alignItems="flex-start"
          flexGrow="1"
        >
          <Typography
            variant="label"
            color="footer-blue"
            htmlTag="p"
            margin={0}
            marginTop={1}
            fontWeight="normal"
            paddingRight={1}
          >
            {formatCardCollectionDate(vehicle.collectionStartDate)}
          </Typography>
          <Typography
            variant="label"
            color="grey-blue"
            htmlTag="p"
            margin={0}
            marginTop={1}
            fontWeight="normal"
          >
            {formatCollectionTime(
              vehicle.collectionStartDate,
              vehicle.collectionEndDate
            )}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Collection;
